import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	xmlSpace: "preserve",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5,21.875c0-4.661,3.777-8.438,8.438-8.438h73.125c4.661,0,8.438,3.777,8.438,8.438  s-3.777,8.438-8.438,8.438H13.438C8.777,30.312,5,26.536,5,21.875z M86.562,41.562H13.438C8.777,41.562,5,45.339,5,50  s3.777,8.438,8.438,8.438h73.125C91.223,58.438,95,54.661,95,50S91.223,41.562,86.562,41.562z M86.562,69.688H13.438  C8.777,69.688,5,73.464,5,78.125s3.777,8.438,8.438,8.438h73.125c4.661,0,8.438-3.777,8.438-8.438S91.223,69.688,86.562,69.688z" })
});
export default SvgHamburger;
